import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { PRODUCT_LABEL } from './adminConstants';

type Row = { id: string; name?: string; surname?: string; email: string; confirmed: boolean; products: number[]; faculty?: string | null; groups: number };

const PAGE = 25;

export default function AdminUsers() {
    const [rows, setRows] = useState<Row[]>([]);
    const [total, setTotal] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [search, setSearch] = useState("");
    const [skip, setSkip] = useState(0);
    const debounce = useRef<ReturnType<typeof setTimeout>>();
    const didMount = useRef(false);
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { load(); }, [skip]);
    useEffect(() => {
        if (!didMount.current) { didMount.current = true; return; }
        clearTimeout(debounce.current);
        debounce.current = setTimeout(() => { skip === 0 ? load() : setSkip(0); }, 300);
        return () => clearTimeout(debounce.current);
    }, [search]);

    async function load() {
        try {
            const res = await api.adminUsersApi.list({ search: search.trim() || undefined, skip, take: PAGE });
            const data = await res.json();
            setRows(data.rows);
            setTotal(data.total);
        } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Studenti</h1><p>Správa účtů, přístupů, skupin a cílů</p></div>
            </div>

            <div className="searchBar">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#33658A" strokeWidth="1.8" strokeLinecap="round"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></svg>
                <input placeholder="Hledat podle jména nebo e-mailu…" value={search} onChange={e => setSearch(e.target.value)} />
            </div>

            <table className="aTable">
                <thead><tr><th>Jméno</th><th>E-mail</th><th>Ověřen</th><th>Produkty</th><th>Fakulta</th><th>Skupiny</th></tr></thead>
                <tbody>
                    {rows.map(r => (
                        <tr key={r.id} onClick={() => navigate("/admin/studenti/" + r.id)}>
                            <td>{(r.name || "") + " " + (r.surname || "") || "—"}</td>
                            <td>{r.email}</td>
                            <td>{r.confirmed ? <span className="ok">ano</span> : <span className="no">ne</span>}</td>
                            <td>{r.products.length ? r.products.map(p => <span key={p} className="tag">{PRODUCT_LABEL[p] ?? p}</span>) : <span className="muted">—</span>}</td>
                            <td>{r.faculty || <span className="muted">—</span>}</td>
                            <td>{r.groups || <span className="muted">0</span>}</td>
                        </tr>
                    ))}
                    {loaded && rows.length === 0 && <tr><td colSpan={6} className="muted">Žádní studenti.</td></tr>}
                </tbody>
            </table>

            <div className="aPager">
                <button disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - PAGE))}>← Předchozí</button>
                <span>{total === 0 ? 0 : skip + 1}–{Math.min(skip + PAGE, total)} z {total}</span>
                <button disabled={skip + PAGE >= total} onClick={() => setSkip(skip + PAGE)}>Další →</button>
            </div>
        </div>
    );
}
